import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-57036304"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container",
  id: "contact"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" alt=\"\" data-v-57036304><div class=\"address\" data-v-57036304>公司地址:北京市海淀区紫金数码园3号楼</div><div class=\"mail\" data-v-57036304>联系邮箱:connect@nineday.net</div><div class=\"line\" data-v-57036304></div><div class=\"desc\" data-v-57036304>京ICP备2021014276号-1</div>", 5)
const _hoisted_7 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_7))
}